import React, { useState } from "react";
import { setGlobalLoading } from "../context/LoaderController";
import { searchVoterByNumber } from "../services/api";
import {
  LOCALSTORAGE_SELECTED_STATE_CODE,
  LOCALSTORAGE_SELECTED_STATE_NAME,
  PAGE_TITLE_VOTER_SEARCH,
  ENTER_MEMBER_ID_LABEL,
  SEARCH_PLACEHOLDER,
  BUTTON_LABEL_SEARCH,
  BUTTON_LABEL_SEARCHING,
  ERROR_EMPTY_QUERY,
  ERROR_NO_RESULTS,
  RESULTS_HEADER,
  NO_RESULTS_TO_SHOW_1,
  NO_RESULTS_TO_SHOW_2,
  VOTER_STATUS_CLASSES,
} from "../components/constants";
import "../App.css";

export default function VoterSearch() {
  const storedStateCode =
    localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_CODE) || "";
  const storedStateName =
    localStorage.getItem(LOCALSTORAGE_SELECTED_STATE_NAME) || "";
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState("");

  const validate = () => {
    if (!query.trim()) {
      setError(ERROR_EMPTY_QUERY);
      return false;
    }
    return true;
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setError("");
    setResults([]);

    if (!validate()) return;

    let mounted = true;
    setLoading(true);
    setGlobalLoading(true);

    try {
      const data = await searchVoterByNumber(storedStateCode, query.trim());
      if (!mounted) return;

      setError(null);
      setResults(Array.isArray(data) ? data : []);
    } catch (err) {
      if (!mounted) return;
      console.error("Search error:", err);
      setError(ERROR_NO_RESULTS);
      setResults([]);
    } finally {
      if (mounted) {
        setLoading(false);
        setGlobalLoading(false);
      }
    }
  };

  return (
    <div className="main-container">
      <h2 className="section-title">{PAGE_TITLE_VOTER_SEARCH}</h2>

      {storedStateName && (
        <span className="iyc-badge">
          State: <strong>{storedStateName}</strong>
        </span>
      )}

      <form
        onSubmit={handleSearch}
        className="search-form"
        style={{ marginBottom: 18 }}
      >
        <div className="input-group">
          <label htmlFor="search-query">{ENTER_MEMBER_ID_LABEL}</label>
          <input
            id="search-query"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={SEARCH_PLACEHOLDER}
            aria-label="Search query"
          />
        </div>
        <div>
          <button className="cta-btn" type="submit" disabled={loading}>
            {loading ? BUTTON_LABEL_SEARCHING : BUTTON_LABEL_SEARCH}
          </button>
        </div>
      </form>

      {error && (
        <div className="error-text" style={{ marginTop: 12, color: "red" }}>
          {error}
        </div>
      )}

      <section>
        <h3
          style={{
            borderBottom: "2px solid var(--primary)",
            paddingBottom: 6,
            marginBottom: 20,
            color: "var(--primary)",
            fontWeight: 600,
            fontFamily: "var(--font-family-app)",
          }}
        >
          {RESULTS_HEADER}
        </h3>

        {loading ? (
          <p>{BUTTON_LABEL_SEARCHING}</p>
        ) : error && results.length === 0 ? (
          <p>{NO_RESULTS_TO_SHOW_1}</p>
        ) : results.length === 0 ? (
          <p>{NO_RESULTS_TO_SHOW_2}</p>
        ) : (
          // ⭐ NEW — Scrollbar-at-top wrapper
          <div className="scroll-top-container">
            <div className="scroll-top-inner">
              <table className="stylish-table">
                <thead>
                  <tr>
                    <th>Member ID</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>DOB</th>
                    <th>Relative</th>
                    <th>Voter ID</th>
                    <th>Status</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((r) => (
                    <tr key={r.id}>
                      <td>{r.memberId}</td>
                      <td>{r.fullName}</td>
                      <td>{r.mobile}</td>
                      <td>{r.dob}</td>
                      <td>{r.relativeName}</td>
                      <td>{r.idValue}</td>
                      <td className={VOTER_STATUS_CLASSES[r.status] || "status-default"}>
  {r.status}
</td>
                      <td>{r.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
